import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'acronym'
})
export class AcronymPipe implements PipeTransform {

    transform(value: string): any {
        if (!value || typeof value !== 'string') { return value; }

        return value.match(/\b(\w)/g).join('');
    }

}
